import React, { useState } from 'react';
import AdminNav from '../adminNav';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import SaveIcon from '@mui/icons-material/Save';
import Alert from '@mui/material/Alert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import axios from 'axios';

const AddResturent = () => {
  const [resturentName, setResturentName] = useState('');
  const [resturentNameAr, setResturentNameAr] = useState('');
  const [resturentImage, setResturentImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [isBilingual, setIsBilingual] = useState(false);
  const [location, setLocation] = useState('');
  const [locationLink, setLocationLink] = useState('');
  const [locationLabel, setLocationLabel] = useState('');
  const [locationLabelAr, setLocationLabelAr] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [facebookLink, setFacebookLink] = useState('');
  const [instagramLink, setInstagramLink] = useState('');
  const [whatsappLink, setWhatsappLink] = useState('');
  const [primaryColor, setPrimaryColor] = useState('#ec4913');
  const [backgroundColor, setBackgroundColor] = useState('#1a1410');
  const [categories, setCategories] = useState([]);
  const [expandedCatIndex, setExpandedCatIndex] = useState(null);
  const [expandedSubIndex, setExpandedSubIndex] = useState(null);
  const [saveMessage, setSaveMessage] = useState('');
  const [saveError, setSaveError] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [menuLink, setMenuLink] = useState('');

  // Category form
  const [categoryName, setCategoryName] = useState('');
  const [categoryNameAr, setCategoryNameAr] = useState('');

  // Subcategory form
  const [subCategoryName, setSubCategoryName] = useState('');
  const [subCategoryNameAr, setSubCategoryNameAr] = useState('');

  // Item form
  const [itemName, setItemName] = useState('');
  const [itemNameAr, setItemNameAr] = useState('');
  const [itemTitle, setItemTitle] = useState('');
  const [itemTitleAr, setItemTitleAr] = useState('');
  const [itemDesc, setItemDesc] = useState('');
  const [itemDescAr, setItemDescAr] = useState('');
  const [itemPrice, setItemPrice] = useState('');
  const [itemImage, setItemImage] = useState('');

  const addCategory = () => {
    if (!categoryName.trim()) return;
    const newCategory = {
      categoryName: categoryName.trim(),
      categoryNameAr: isBilingual ? categoryNameAr.trim() : '',
      subCategories: []
    };
    setCategories([...categories, newCategory]);
    setCategoryName('');
    setCategoryNameAr('');
  };

  const deleteCategory = (catIndex) => {
    const updated = categories.filter((_, i) => i !== catIndex);
    setCategories(updated);
    if (expandedCatIndex === catIndex) setExpandedCatIndex(null);
  };

  const toggleSubCategories = (index) => {
    setExpandedCatIndex((prev) => (prev === index ? null : index));
    setExpandedSubIndex(null);
  };

  const addSubCategory = (catIndex) => {
    if (!subCategoryName.trim()) return;
    const updated = [...categories];
    const newSubCategory = {
      name: subCategoryName.trim(),
      nameAr: isBilingual ? subCategoryNameAr.trim() : '',
      items: []
    };
    updated[catIndex].subCategories.push(newSubCategory);
    setCategories(updated);
    setSubCategoryName('');
    setSubCategoryNameAr('');
  };

  const deleteSubCategory = (catIndex, subIndex) => {
    const updated = [...categories];
    updated[catIndex].subCategories = updated[catIndex].subCategories.filter((_, i) => i !== subIndex);
    setCategories(updated);
    if (expandedSubIndex === subIndex) setExpandedSubIndex(null);
  };

  const toggleItems = (subIndex) => {
    setExpandedSubIndex((prev) => (prev === subIndex ? null : subIndex));
  };

  const addItem = (catIndex, subIndex) => {
    if (!itemName.trim()) return;
    const updated = [...categories];
    const newItem = {
      name: itemName.trim(),
      nameAr: isBilingual ? itemNameAr.trim() : '',
      title: itemTitle.trim(),
      titleAr: isBilingual ? itemTitleAr.trim() : '',
      desc: itemDesc.trim(),
      descAr: isBilingual ? itemDescAr.trim() : '',
      price: itemPrice,
      image: itemImage,
    };
    updated[catIndex].subCategories[subIndex].items.push(newItem);
    setCategories(updated);
    setItemName('');
    setItemNameAr('');
    setItemTitle('');
    setItemTitleAr('');
    setItemDesc('');
    setItemDescAr('');
    setItemPrice('');
    setItemImage('');
  };

  const deleteItem = (catIndex, subIndex, itemIndex) => {
    const updated = [...categories];
    updated[catIndex].subCategories[subIndex].items = updated[catIndex].subCategories[subIndex].items.filter((_, i) => i !== itemIndex);
    setCategories(updated);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setResturentImage(file);
      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setResturentImage(null);
    setImagePreview('');
  };

  const saveRestaurant = async () => {
    if (!resturentName.trim()) {
      setSaveError('Restaurant name is required');
      setSaveMessage('');
      return;
    }

    setIsSaving(true);
    setSaveError('');
    setSaveMessage('');

    const token = localStorage.getItem('auth-token');
    
    try {
      const formData = new FormData();
      formData.append('resturentName', resturentName.trim());
      if (isBilingual && resturentNameAr.trim()) {
        formData.append('resturentNameAr', resturentNameAr.trim());
      }
      formData.append('categories', JSON.stringify(categories));
      formData.append('isBilingual', isBilingual);
      formData.append('location', location.trim());
      formData.append('locationLink', locationLink.trim());
      formData.append('locationLabel', locationLabel.trim());
      formData.append('locationLabelAr', locationLabelAr.trim());
      formData.append('phoneNumber', phoneNumber.trim());
      formData.append('facebookLink', facebookLink.trim());
      formData.append('instagramLink', instagramLink.trim());
      formData.append('whatsappLink', whatsappLink.trim());
      formData.append('primaryColor', primaryColor.trim() || '#ec4913');
      formData.append('backgroundColor', backgroundColor.trim() || '#1a1410');
      if (resturentImage) {
        formData.append('resturentImage', resturentImage);
      }

      const response = await axios.post(
        '/addResturent',
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setSaveMessage('Restaurant saved successfully!');
      setSaveError('');
      
      // Set QR code and menu link from response
      if (response.data.qr) {
        setQrCodeUrl(response.data.qr);
      }
      if (response.data.menuLink) {
        setMenuLink(response.data.menuLink);
      }
      
      // Optionally clear form or keep data
      // setResturentName('');
      // setResturentImage(null);
      // setImagePreview('');
      // setCategories([]);
    } catch (err) {
      setSaveError(err.response?.data?.message || 'Failed to save restaurant');
      setSaveMessage('');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <AdminNav />
      <Container 
        className='add-resturent-container'
        maxWidth="lg" 
        sx={{ 
          py: { xs: 2, sm: 3, md: 4 },
          px: { xs: 2, sm: 3 }
        }}
      >
        <Box 
          sx={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: { xs: 2, sm: 3 },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2
          }}
        >
          <Typography 
            variant="h4" 
            sx={{ 
              fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' },
              fontWeight: 600,
              color: 'primary.main'
            }}
          >
            Add Restaurant Menu
          </Typography>
          <Button
            variant="contained"
            color="success"
            size="large"
            startIcon={<SaveIcon />}
            onClick={saveRestaurant}
            disabled={isSaving || !resturentName.trim()}
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '1rem',
              boxShadow: 3,
              '&:hover': {
                boxShadow: 6
              }
            }}
          >
            {isSaving ? 'Saving...' : 'Save Restaurant'}
          </Button>
        </Box>

        {saveMessage && (
          <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSaveMessage('')}>
            {saveMessage}
          </Alert>
        )}
        {saveError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setSaveError('')}>
            {saveError}
          </Alert>
        )}

        {qrCodeUrl && (
          <Card 
            sx={{ 
              mb: { xs: 2, sm: 3 },
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              borderRadius: 2,
              bgcolor: 'success.lighter'
            }}
          >
            <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
              <Typography 
                variant="h6" 
                gutterBottom
                sx={{ 
                  fontSize: { xs: '1rem', sm: '1.125rem' },
                  fontWeight: 600,
                  mb: 2,
                  color: 'success.dark'
                }}
              >
                QR Code Generated Successfully
              </Typography>
              <Box 
                sx={{ 
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: 'center',
                  gap: 3
                }}
              >
                <Box 
                  sx={{ 
                    bgcolor: 'white',
                    p: 2,
                    borderRadius: 2,
                    boxShadow: 2
                  }}
                >
                  <img 
                    src={qrCodeUrl} 
                    alt="Restaurant Menu QR Code" 
                    style={{ 
                      width: '200px', 
                      height: '200px',
                      display: 'block'
                    }} 
                  />
                </Box>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
                    Menu Link:
                  </Typography>
                  <TextField
                    fullWidth
                    value={menuLink}
                    InputProps={{
                      readOnly: true,
                    }}
                    size="small"
                    sx={{
                      mb: 2,
                      '& .MuiOutlinedInput-root': {
                        bgcolor: 'white',
                        borderRadius: 1.5
                      }
                    }}
                  />
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => window.open(qrCodeUrl, '_blank')}
                      sx={{
                        textTransform: 'none',
                        borderRadius: 1.5,
                        fontWeight: 600
                      }}
                    >
                      Download QR Code
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => window.open(menuLink, '_blank')}
                      sx={{
                        textTransform: 'none',
                        borderRadius: 1.5,
                        fontWeight: 600
                      }}
                    >
                      View Menu
                    </Button>
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        )}

        {/* Restaurant name and image */}
        <Card 
          sx={{ 
            mb: { xs: 2, sm: 3 },
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            borderRadius: 2
          }}
        >
          <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography 
              variant="h6" 
              gutterBottom
              sx={{ 
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 600,
                mb: 2
              }}
            >
              Restaurant Information
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: isBilingual ? '1fr 1fr' : '1fr', gap: 2, mb: 3 }}>
              <TextField
                label="Restaurant Name (English)"
                variant="outlined"
                fullWidth
                value={resturentName}
                onChange={(e) => setResturentName(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1.5
                  }
                }}
              />
              {isBilingual && (
                <TextField
                  label="اسم المطعم (عربي)"
                  variant="outlined"
                  fullWidth
                  value={resturentNameAr}
                  onChange={(e) => setResturentNameAr(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1.5
                    },
                    direction: 'rtl'
                  }}
                  inputProps={{
                    dir: 'rtl'
                  }}
                />
              )}
            </Box>

            {/* Image Upload */}
            <Box sx={{ mb: 2 }}>
              <Typography 
                variant="body2" 
                sx={{ mb: 1, fontWeight: 600 }}
              >
                Restaurant Image
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Button
                  variant="outlined"
                  component="label"
                  sx={{
                    textTransform: 'none',
                    borderRadius: 1.5,
                    py: 1.5
                  }}
                >
                  {imagePreview ? 'Change Image' : 'Upload Image'}
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </Button>
                
                {imagePreview && (
                  <Box 
                    sx={{ 
                      position: 'relative',
                      width: 'fit-content'
                    }}
                  >
                    <img 
                      src={imagePreview} 
                      alt="Restaurant preview" 
                      style={{ 
                        maxWidth: '300px',
                        maxHeight: '200px',
                        borderRadius: '8px',
                        objectFit: 'cover'
                      }} 
                    />
                    <IconButton
                      onClick={removeImage}
                      sx={{
                        position: 'absolute',
                        top: -10,
                        right: -10,
                        bgcolor: 'error.main',
                        color: 'white',
                        '&:hover': {
                          bgcolor: 'error.dark'
                        }
                      }}
                      size="small"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </Box>

            {/* Menu Colors */}
            <Box sx={{ mt: 3, mb: 3 }}>
              <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600 }}>
                Menu Colors
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                <Box>
                  <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'text.secondary' }}>Orange / Accent Color</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <input
                      type="color"
                      value={primaryColor}
                      onChange={(e) => setPrimaryColor(e.target.value)}
                      style={{
                        width: 48,
                        height: 40,
                        border: '1px solid #ccc',
                        borderRadius: 8,
                        cursor: 'pointer',
                        padding: 2
                      }}
                    />
                    <TextField
                      size="small"
                      value={primaryColor}
                      onChange={(e) => setPrimaryColor(e.target.value)}
                      placeholder="#ec4913"
                      sx={{ flex: 1, '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'text.secondary' }}>Background Color</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <input
                      type="color"
                      value={backgroundColor}
                      onChange={(e) => setBackgroundColor(e.target.value)}
                      style={{
                        width: 48,
                        height: 40,
                        border: '1px solid #ccc',
                        borderRadius: 8,
                        cursor: 'pointer',
                        padding: 2
                      }}
                    />
                    <TextField
                      size="small"
                      value={backgroundColor}
                      onChange={(e) => setBackgroundColor(e.target.value)}
                      placeholder="#1a1410"
                      sx={{ flex: 1, '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Location & Social Links */}
            <Box sx={{ mt: 3, mb: 3 }}>
              <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600 }}>
                Location & Social Media
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                <TextField
                  label="Location Link (URL)"
                  variant="outlined"
                  fullWidth
                  value={locationLink}
                  onChange={(e) => setLocationLink(e.target.value)}
                  placeholder="e.g. https://maps.google.com/... or Google Maps link"
                  sx={{ gridColumn: { xs: '1', sm: 'span 2' }, '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                <TextField
                  label="Location Label (English)"
                  variant="outlined"
                  fullWidth
                  value={locationLabel}
                  onChange={(e) => setLocationLabel(e.target.value)}
                  placeholder="e.g. Main Branch, Downtown"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                {isBilingual && (
                  <TextField
                    label="عنوان الموقع (عربي)"
                    variant="outlined"
                    fullWidth
                    value={locationLabelAr}
                    onChange={(e) => setLocationLabelAr(e.target.value)}
                    placeholder="مثال: الفرع الرئيسي"
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 }, direction: 'rtl' }}
                    inputProps={{ dir: 'rtl' }}
                  />
                )}
                <TextField
                  label="Phone (for call)"
                  variant="outlined"
                  fullWidth
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="e.g. +1234567890"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                <TextField
                  label="Facebook URL"
                  variant="outlined"
                  fullWidth
                  value={facebookLink}
                  onChange={(e) => setFacebookLink(e.target.value)}
                  placeholder="https://facebook.com/..."
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                <TextField
                  label="Instagram URL"
                  variant="outlined"
                  fullWidth
                  value={instagramLink}
                  onChange={(e) => setInstagramLink(e.target.value)}
                  placeholder="https://instagram.com/..."
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                <TextField
                  label="WhatsApp (e.g. +1234567890)"
                  variant="outlined"
                  fullWidth
                  value={whatsappLink}
                  onChange={(e) => setWhatsappLink(e.target.value)}
                  placeholder="+1234567890 or wa.me link"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
              </Box>
            </Box>

            {/* Language Options */}
            <Box sx={{ mt: 3 }}>
              <Typography 
                variant="body2" 
                sx={{ mb: 1.5, fontWeight: 600 }}
              >
                Language Options
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isBilingual}
                    onChange={(e) => setIsBilingual(e.target.checked)}
                    sx={{
                      color: '#86C85D',
                      '&.Mui-checked': {
                        color: '#86C85D',
                      }
                    }}
                  />
                }
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2">
                      Make menu available in Arabic and English
                    </Typography>
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        bgcolor: '#86C85D',
                        color: 'white',
                        px: 1.5,
                        py: 0.5,
                        borderRadius: 1,
                        fontWeight: 600
                      }}
                    >
                      Bilingual
                    </Typography>
                  </Box>
                }
                sx={{
                  bgcolor: isBilingual ? 'rgba(134, 200, 93, 0.08)' : 'grey.50',
                  border: '1px solid',
                  borderColor: isBilingual ? '#86C85D' : 'grey.300',
                  borderRadius: 1.5,
                  p: 2,
                  m: 0,
                  width: '100%',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    bgcolor: isBilingual ? 'rgba(134, 200, 93, 0.12)' : 'grey.100',
                  }
                }}
              />
              {isBilingual && (
                <Alert 
                  severity="info" 
                  sx={{ 
                    mt: 2,
                    borderRadius: 1.5,
                    '& .MuiAlert-icon': {
                      color: '#86C85D'
                    }
                  }}
                >
                  Customers will be able to view your menu in both Arabic and English languages.
                </Alert>
              )}
            </Box>
          </CardContent>
        </Card>

        {/* Add Category */}
        <Card 
          sx={{ 
            mb: { xs: 2, sm: 3 },
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            borderRadius: 2
          }}
        >
          <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography 
              variant="h6" 
              gutterBottom
              sx={{ 
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 600,
                mb: 2
              }}
            >
              Menu Categories
            </Typography>
            <Box sx={{ mb: 3 }}>
              <Box 
                sx={{ 
                  display: 'grid',
                  gridTemplateColumns: isBilingual ? { xs: '1fr', sm: '1fr 1fr' } : '1fr',
                  gap: 2,
                  mb: 2
                }}
              >
                <TextField
                  label="Category Name (English)"
                  variant="outlined"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && addCategory()}
                  sx={{ 
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1.5
                    }
                  }}
                />
                {isBilingual && (
                  <TextField
                    label="اسم الفئة (عربي)"
                    variant="outlined"
                    value={categoryNameAr}
                    onChange={(e) => setCategoryNameAr(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && addCategory()}
                    sx={{ 
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5
                      },
                      direction: 'rtl'
                    }}
                    inputProps={{
                      dir: 'rtl'
                    }}
                  />
                )}
              </Box>
              <Button 
                variant="contained" 
                startIcon={<AddIcon />} 
                onClick={addCategory}
                fullWidth
                sx={{
                  py: 1.5,
                  borderRadius: 1.5,
                  textTransform: 'none',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4
                  }
                }}
              >
                Add Category
              </Button>
            </Box>

            {/* Categories list */}
            {categories.length > 0 && (
              <List sx={{ p: 0 }}>
                {categories.map((cat, catIndex) => {
                  const isExpanded = expandedCatIndex === catIndex;
                  const subCategories = cat.subCategories || [];
                  return (
                    <Card 
                      key={catIndex} 
                      sx={{ 
                        mb: 2,
                        border: '2px solid',
                        borderColor: isExpanded ? 'primary.main' : 'divider',
                        borderRadius: 2,
                        boxShadow: isExpanded ? '0 4px 12px rgba(0,0,0,0.15)' : '0 1px 4px rgba(0,0,0,0.08)',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
                        <Box 
                          sx={{ 
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            alignItems: { xs: 'flex-start', sm: 'center' },
                            justifyContent: 'space-between',
                            gap: { xs: 1.5, sm: 1 },
                            mb: isExpanded ? 2 : 0
                          }}
                        >
                          <Box>
                            <Typography 
                              variant="subtitle1" 
                              sx={{
                                fontWeight: 700,
                                fontSize: { xs: '1rem', sm: '1.125rem' },
                                color: 'text.primary'
                              }}
                            >
                              {cat.categoryName}
                            </Typography>
                            {isBilingual && cat.categoryNameAr && (
                              <Typography 
                                variant="body2" 
                                sx={{
                                  color: 'text.secondary',
                                  fontStyle: 'italic',
                                  direction: 'rtl'
                                }}
                              >
                                {cat.categoryNameAr}
                              </Typography>
                            )}
                          </Box>
                          <Box 
                            sx={{ 
                              display: 'flex',
                              gap: 1,
                              width: { xs: '100%', sm: 'auto' }
                            }}
                          >
                            <Button
                              size="small"
                              variant={isExpanded ? 'contained' : 'outlined'}
                              startIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                              onClick={() => toggleSubCategories(catIndex)}
                              sx={{
                                flexGrow: { xs: 1, sm: 0 },
                                textTransform: 'none',
                                borderRadius: 1.5,
                                fontSize: '0.813rem',
                                fontWeight: 600,
                                px: 2
                              }}
                            >
                              {isExpanded ? 'Hide' : 'Show'} Subs
                            </Button>
                            <IconButton 
                              size="small" 
                              color="error" 
                              onClick={() => deleteCategory(catIndex)}
                              sx={{
                                bgcolor: 'error.lighter',
                                '&:hover': {
                                  bgcolor: 'error.light'
                                }
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </Box>

                        {/* Subcategories section (when expanded) */}
                        {isExpanded && (
                          <Box 
                            sx={{ 
                              pl: { xs: 0, sm: 2 },
                              pt: 2,
                              borderTop: '2px solid',
                              borderColor: 'primary.light',
                              bgcolor: 'grey.50',
                              p: { xs: 2, sm: 2.5 },
                              borderRadius: 1.5,
                              mt: 1
                            }}
                          >
                            <Typography 
                              variant="subtitle2" 
                              gutterBottom
                              sx={{ 
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                color: 'text.secondary',
                                mb: 1.5
                              }}
                            >
                              Add Subcategory
                            </Typography>
                            <Box sx={{ mb: 2 }}>
                              <Box 
                                sx={{ 
                                  display: 'grid',
                                  gridTemplateColumns: isBilingual ? { xs: '1fr', sm: '1fr 1fr' } : '1fr',
                                  gap: 1,
                                  mb: 1
                                }}
                              >
                                <TextField
                                  label="Subcategory Name (English)"
                                  size="small"
                                  value={subCategoryName}
                                  onChange={(e) => setSubCategoryName(e.target.value)}
                                  onKeyDown={(e) => e.key === 'Enter' && addSubCategory(catIndex)}
                                  sx={{ 
                                    bgcolor: 'white',
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: 1.5
                                    }
                                  }}
                                />
                                {isBilingual && (
                                  <TextField
                                    label="اسم الفئة الفرعية (عربي)"
                                    size="small"
                                    value={subCategoryNameAr}
                                    onChange={(e) => setSubCategoryNameAr(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && addSubCategory(catIndex)}
                                    sx={{ 
                                      bgcolor: 'white',
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: 1.5
                                      },
                                      direction: 'rtl'
                                    }}
                                    inputProps={{
                                      dir: 'rtl'
                                    }}
                                  />
                                )}
                              </Box>
                              <Button 
                                size="small" 
                                variant="contained" 
                                startIcon={<AddIcon />} 
                                onClick={() => addSubCategory(catIndex)}
                                fullWidth
                                sx={{
                                  textTransform: 'none',
                                  borderRadius: 1.5,
                                  fontWeight: 600
                                }}
                              >
                                Add Subcategory
                              </Button>
                            </Box>

                            {/* Subcategories list */}
                            {subCategories.length > 0 && (
                              <List dense sx={{ p: 0 }}>
                                {subCategories.map((sub, subIndex) => {
                                  const isSubExpanded = expandedSubIndex === subIndex;
                                  const items = sub.items || [];
                                  return (
                                    <Card 
                                      key={subIndex} 
                                      variant="outlined" 
                                      sx={{ 
                                        mb: 1.5,
                                        bgcolor: 'white',
                                        border: isSubExpanded ? '2px solid' : '1px solid',
                                        borderColor: isSubExpanded ? 'secondary.main' : 'grey.300',
                                        borderRadius: 1.5,
                                        boxShadow: isSubExpanded ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
                                        transition: 'all 0.2s ease'
                                      }}
                                    >
                                      <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                                        <Box 
                                          sx={{ 
                                            display: 'flex',
                                            flexDirection: { xs: 'column', sm: 'row' },
                                            alignItems: { xs: 'flex-start', sm: 'center' },
                                            justifyContent: 'space-between',
                                            gap: 1,
                                            mb: isSubExpanded ? 1.5 : 0
                                          }}
                                        >
                                          <Box>
                                            <Typography 
                                              variant="body2" 
                                              sx={{
                                                fontWeight: 600,
                                                fontSize: '0.938rem',
                                                color: 'text.primary'
                                              }}
                                            >
                                              {sub.name}
                                            </Typography>
                                            {isBilingual && sub.nameAr && (
                                              <Typography 
                                                variant="caption" 
                                                sx={{
                                                  color: 'text.secondary',
                                                  fontStyle: 'italic',
                                                  direction: 'rtl',
                                                  display: 'block'
                                                }}
                                              >
                                                {sub.nameAr}
                                              </Typography>
                                            )}
                                          </Box>
                                          <Box 
                                            sx={{ 
                                              display: 'flex',
                                              gap: 0.5,
                                              width: { xs: '100%', sm: 'auto' }
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              variant={isSubExpanded ? 'contained' : 'outlined'}
                                              onClick={() => toggleItems(subIndex)}
                                              sx={{ 
                                                flexGrow: { xs: 1, sm: 0 },
                                                fontSize: '0.75rem',
                                                textTransform: 'none',
                                                borderRadius: 1,
                                                px: 1.5,
                                                fontWeight: 600
                                              }}
                                            >
                                              {isSubExpanded ? 'Hide Items' : 'Add Items'}
                                            </Button>
                                            <IconButton 
                                              size="small" 
                                              color="error" 
                                              onClick={() => deleteSubCategory(catIndex, subIndex)}
                                              sx={{
                                                bgcolor: 'error.lighter',
                                                '&:hover': {
                                                  bgcolor: 'error.light'
                                                }
                                              }}
                                            >
                                              <DeleteIcon fontSize="small" />
                                            </IconButton>
                                          </Box>
                                        </Box>

                                        {/* Items section (when subcategory expanded) */}
                                        {isSubExpanded && (
                                          <Box 
                                            sx={{ 
                                              pt: 2,
                                              borderTop: '1px dashed',
                                              borderColor: 'grey.300',
                                              bgcolor: 'grey.50',
                                              p: { xs: 1.5, sm: 2 },
                                              borderRadius: 1,
                                              mt: 1
                                            }}
                                          >
                                            <Typography 
                                              variant="caption" 
                                              display="block" 
                                              gutterBottom
                                              sx={{ 
                                                fontWeight: 600,
                                                fontSize: '0.813rem',
                                                color: 'text.secondary',
                                                mb: 1.5
                                              }}
                                            >
                                              Add Item Details
                                            </Typography>
                                            <Box 
                                              sx={{ 
                                                display: 'grid',
                                                gridTemplateColumns: '1fr',
                                                gap: 1.5,
                                                mb: 2
                                              }}
                                            >
                                              {/* Item Name */}
                                              <Box sx={{ display: 'grid', gridTemplateColumns: isBilingual ? '1fr 1fr' : '1fr', gap: 1.5 }}>
                                                <TextField 
                                                  label="Item Name (English)" 
                                                  size="small" 
                                                  value={itemName} 
                                                  onChange={(e) => setItemName(e.target.value)}
                                                  sx={{ 
                                                    bgcolor: 'white',
                                                    '& .MuiOutlinedInput-root': {
                                                      borderRadius: 1.5
                                                    }
                                                  }}
                                                />
                                                {isBilingual && (
                                                  <TextField 
                                                    label="اسم الصنف (عربي)" 
                                                    size="small" 
                                                    value={itemNameAr} 
                                                    onChange={(e) => setItemNameAr(e.target.value)}
                                                    sx={{ 
                                                      bgcolor: 'white',
                                                      '& .MuiOutlinedInput-root': {
                                                        borderRadius: 1.5
                                                      },
                                                      direction: 'rtl'
                                                    }}
                                                    inputProps={{
                                                      dir: 'rtl'
                                                    }}
                                                  />
                                                )}
                                              </Box>

                                              {/* Item Title */}
                                              <Box sx={{ display: 'grid', gridTemplateColumns: isBilingual ? '1fr 1fr' : '1fr', gap: 1.5 }}>
                                                <TextField 
                                                  label="Title (English)" 
                                                  size="small" 
                                                  value={itemTitle} 
                                                  onChange={(e) => setItemTitle(e.target.value)}
                                                  sx={{ 
                                                    bgcolor: 'white',
                                                    '& .MuiOutlinedInput-root': {
                                                      borderRadius: 1.5
                                                    }
                                                  }}
                                                />
                                                {isBilingual && (
                                                  <TextField 
                                                    label="العنوان (عربي)" 
                                                    size="small" 
                                                    value={itemTitleAr} 
                                                    onChange={(e) => setItemTitleAr(e.target.value)}
                                                    sx={{ 
                                                      bgcolor: 'white',
                                                      '& .MuiOutlinedInput-root': {
                                                        borderRadius: 1.5
                                                      },
                                                      direction: 'rtl'
                                                    }}
                                                    inputProps={{
                                                      dir: 'rtl'
                                                    }}
                                                  />
                                                )}
                                              </Box>

                                              {/* Item Description */}
                                              <Box sx={{ display: 'grid', gridTemplateColumns: isBilingual ? '1fr 1fr' : '1fr', gap: 1.5 }}>
                                                <TextField 
                                                  label="Description (English)" 
                                                  size="small" 
                                                  multiline 
                                                  rows={2} 
                                                  value={itemDesc} 
                                                  onChange={(e) => setItemDesc(e.target.value)}
                                                  sx={{ 
                                                    bgcolor: 'white',
                                                    '& .MuiOutlinedInput-root': {
                                                      borderRadius: 1.5
                                                    }
                                                  }}
                                                />
                                                {isBilingual && (
                                                  <TextField 
                                                    label="الوصف (عربي)" 
                                                    size="small" 
                                                    multiline 
                                                    rows={2} 
                                                    value={itemDescAr} 
                                                    onChange={(e) => setItemDescAr(e.target.value)}
                                                    sx={{ 
                                                      bgcolor: 'white',
                                                      '& .MuiOutlinedInput-root': {
                                                        borderRadius: 1.5
                                                      },
                                                      direction: 'rtl'
                                                    }}
                                                    inputProps={{
                                                      dir: 'rtl'
                                                    }}
                                                  />
                                                )}
                                              </Box>

                                              {/* Price and Image */}
                                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
                                                <TextField 
                                                  label="Price" 
                                                  size="small" 
                                                  type="number" 
                                                  value={itemPrice} 
                                                  onChange={(e) => setItemPrice(e.target.value)}
                                                  sx={{ 
                                                    bgcolor: 'white',
                                                    '& .MuiOutlinedInput-root': {
                                                      borderRadius: 1.5
                                                    }
                                                  }}
                                                />
                                                <TextField 
                                                  label="Image URL" 
                                                  size="small" 
                                                  value={itemImage} 
                                                  onChange={(e) => setItemImage(e.target.value)}
                                                  sx={{ 
                                                    bgcolor: 'white',
                                                    '& .MuiOutlinedInput-root': {
                                                      borderRadius: 1.5
                                                    }
                                                  }}
                                                />
                                              </Box>
                                            </Box>
                                            <Button 
                                              size="small" 
                                              variant="contained" 
                                              color="success"
                                              startIcon={<AddIcon />} 
                                              onClick={() => addItem(catIndex, subIndex)}
                                              fullWidth
                                              sx={{
                                                textTransform: 'none',
                                                borderRadius: 1.5,
                                                py: 1,
                                                fontWeight: 600,
                                                fontSize: '0.875rem'
                                              }}
                                            >
                                              Add Item
                                            </Button>

                                            {/* Items list */}
                                            {items.length > 0 && (
                                              <Box sx={{ mt: 2 }}>
                                                <Typography 
                                                  variant="caption" 
                                                  sx={{ 
                                                    fontWeight: 600,
                                                    fontSize: '0.813rem',
                                                    color: 'text.secondary',
                                                    display: 'block',
                                                    mb: 1
                                                  }}
                                                >
                                                  Items List
                                                </Typography>
                                                <List dense disablePadding>
                                                  {items.map((item, itemIndex) => (
                                                    <ListItem 
                                                      key={itemIndex} 
                                                      sx={{ 
                                                        border: '1px solid',
                                                        borderColor: 'grey.300',
                                                        borderRadius: 1.5,
                                                        mb: 1,
                                                        bgcolor: 'white',
                                                        p: 1.5,
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        flexDirection: { xs: 'column', sm: 'row' },
                                                        gap: 1
                                                      }}
                                                    >
                                                      <Box sx={{ flexGrow: 1 }}>
                                                        <Typography 
                                                          variant="body2" 
                                                          sx={{ 
                                                            fontWeight: 600,
                                                            fontSize: '0.875rem',
                                                            mb: 0.5 
                                                          }}
                                                        >
                                                          {item.name || item.title}
                                                        </Typography>
                                                        {isBilingual && (item.nameAr || item.titleAr) && (
                                                          <Typography 
                                                            variant="body2" 
                                                            sx={{ 
                                                              fontWeight: 600,
                                                              fontSize: '0.875rem',
                                                              mb: 0.5,
                                                              color: 'text.secondary',
                                                              direction: 'rtl'
                                                            }}
                                                          >
                                                            {item.nameAr || item.titleAr}
                                                          </Typography>
                                                        )}
                                                        <Typography 
                                                          variant="caption" 
                                                          sx={{ 
                                                            fontSize: '0.75rem',
                                                            color: 'text.secondary',
                                                            display: 'block'
                                                          }}
                                                        >
                                                          {item.desc || 'No description'}
                                                        </Typography>
                                                        {isBilingual && item.descAr && (
                                                          <Typography 
                                                            variant="caption" 
                                                            sx={{ 
                                                              fontSize: '0.75rem',
                                                              color: 'text.secondary',
                                                              display: 'block',
                                                              direction: 'rtl'
                                                            }}
                                                          >
                                                            {item.descAr}
                                                          </Typography>
                                                        )}
                                                        <Typography 
                                                          variant="caption" 
                                                          sx={{ 
                                                            fontSize: '0.75rem',
                                                            color: 'primary.main',
                                                            fontWeight: 600,
                                                            display: 'block',
                                                            mt: 0.5
                                                          }}
                                                        >
                                                          ${item.price || '0'}
                                                        </Typography>
                                                      </Box>
                                                      <IconButton 
                                                        size="small" 
                                                        color="error" 
                                                        onClick={() => deleteItem(catIndex, subIndex, itemIndex)}
                                                        sx={{
                                                          bgcolor: 'error.lighter',
                                                          '&:hover': {
                                                            bgcolor: 'error.light'
                                                          }
                                                        }}
                                                      >
                                                        <DeleteIcon fontSize="small" />
                                                      </IconButton>
                                                    </ListItem>
                                                  ))}
                                                </List>
                                              </Box>
                                            )}
                                            {items.length === 0 && (
                                              <Typography 
                                                variant="caption" 
                                                color="text.secondary"
                                                sx={{ 
                                                  display: 'block',
                                                  textAlign: 'center',
                                                  py: 2,
                                                  fontStyle: 'italic'
                                                }}
                                              >
                                                No items yet
                                              </Typography>
                                            )}
                                          </Box>
                                        )}
                                      </CardContent>
                                    </Card>
                                  );
                                })}
                              </List>
                            )}
                            {subCategories.length === 0 && (
                              <Typography 
                                variant="body2" 
                                color="text.secondary"
                                sx={{ 
                                  textAlign: 'center',
                                  py: 2,
                                  fontStyle: 'italic'
                                }}
                              >
                                No subcategories yet
                              </Typography>
                            )}
                          </Box>
                        )}
                      </CardContent>
                    </Card>
                  );
                })}
              </List>
            )}
            {categories.length === 0 && (
              <Box 
                sx={{ 
                  textAlign: 'center',
                  py: 4,
                  px: 2,
                  bgcolor: 'grey.50',
                  borderRadius: 2,
                  border: '2px dashed',
                  borderColor: 'grey.300'
                }}
              >
                <Typography 
                  variant="body2" 
                  color="text.secondary"
                  sx={{ fontStyle: 'italic' }}
                >
                  No categories yet. Add your first category above to get started!
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>
      </Container>
    </>
  );
};
export default AddResturent;